import { render } from "@/components/pages/specialFeature/spWorkSupport/requirementSpMVS003/RequirementSpMVS003.html?vue&type=template&id=b8c2c83a&scoped=true&external"
import script from "@/components/pages/specialFeature/spWorkSupport/requirementSpMVS003/RequirementSpMVS003.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spWorkSupport/requirementSpMVS003/RequirementSpMVS003.js?vue&type=script&lang=js&external"

import "@/components/pages/specialFeature/spWorkSupport/requirementSpMVS003/RequirementSpMVS003.scss?vue&type=style&index=0&id=b8c2c83a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c2c83a"]])

export default __exports__